/**
 * Pulls the guest's saved outfits out of localStorage once the app has mounted.
 * Same timing, and for the same hydration reason, as `guestWishlist.client.ts`.
 */
export default defineNuxtPlugin({
  name: 'guest-saved-looks',
  setup(nuxtApp) {
    const guest = useGuestSavedLooks()

    nuxtApp.hook('app:mounted', () => {
      guest.load()
    })

    window.addEventListener('storage', (event) => {
      if (event.key === 'guest-saved-looks')
        guest.syncFromStorage()
    })
  },
})
